import { render, staticRenderFns } from "./OctOpticDiscForm.vue?vue&type=template&id=13cc3b48"
import script from "./OctOpticDiscForm.vue?vue&type=script&lang=js"
export * from "./OctOpticDiscForm.vue?vue&type=script&lang=js"
import style0 from "./OctOpticDiscForm.vue?vue&type=style&index=0&id=13cc3b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports